import React from 'react';

// Egendefinert Recharts-tooltip. Bygd kun med <div> og inline-stiler, slik at den ikke treffes av
// den globale span-regelen i common.ui (som ga teal bakgrunn / hvit tekst). Ingen recharts-klasser.
interface TooltipItem {
  name?: string | number;
  value?: string | number;
  color?: string;
}

interface AuditLogTooltipProps {
  active?: boolean;
  payload?: TooltipItem[];
  label?: string | number;
}

const num = (v: string | number | undefined): string =>
  typeof v === 'number' ? v.toLocaleString('no-NO') : v ?? '';

function AuditLogTooltip({ active, payload, label }: AuditLogTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div
      style={{
        background: '#ffffff',
        border: '1px solid #cccccc',
        borderRadius: 4,
        padding: '6px 10px',
        fontSize: 12,
        color: '#222222',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.15)'
      }}
    >
      {label !== undefined && label !== null && label !== '' && (
        <div style={{ fontWeight: 600, marginBottom: 4, color: '#222222' }}>{label}</div>
      )}
      {payload.map((p, i) => (
        <div
          key={`${p.name ?? i}`}
          style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#222222', lineHeight: 1.5 }}
        >
          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: 2,
              background: p.color ?? '#009B96',
              flex: '0 0 auto'
            }}
          />
          <div style={{ color: '#222222' }}>
            {p.name}: {num(p.value)}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AuditLogTooltip;
